import { styled } from '../../../core/theme/styled';

type ScreenWrapperProps = {
  centerHorizontally?: boolean;
  centerVertically?: boolean;
};

export const ScreenWrapper = styled.div<ScreenWrapperProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: ${(props) => (props.centerHorizontally ? 'center' : 'flex-start')};
  align-items: ${(props) => (props.centerVertically ? 'center' : 'stretch')};
`;

export const TintedScreenWrapper = styled(ScreenWrapper)`
  background-color: ${(props) => props.theme.configuration.tintedBackgroundColor};
`;
